export const colors = {
  black: '#000',
  white: '#fff',
  gray: '#ccc',
}
